//Style
import '../scss/style.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis'
import { SplitText } from "gsap/SplitText";
import barba from '@barba/core';
import { ViewHome } from "./ViewHome";
import { TransitionTypo } from "./TransitionTypo";
import { TransitionDefault } from "./TransitionDefault";

gsap.registerPlugin(ScrollTrigger, SplitText)

// Import Swiper e i suoi stili base

import 'swiper/css';
import 'swiper/css/pagination'; // Importa lo stile della paginazione



// Initialize Lenis
import 'lenis/dist/lenis.css'
import { ViewTypo } from "./ViewTypo";
import { ViewProduct } from "./ViewProduct";
import { ViewAbout } from "./ViewAbout";
import { ViewCases } from "./ViewCases";
import { TransitionProduct } from "./TransitionProduct";
import { ViewPage } from "./ViewPage";
import { initDownloadArea } from "./DownloadArea";
import { initPromoBox } from "./PromoBox";

export const lenis = new Lenis({
    autoRaf: true,
    lerp: 0.2,
    duration: 1.3
});

// Listen for the scroll event and log the event data
lenis.on('scroll', (e) => {

    if (e.animatedScroll >= 96) {

        document.querySelector('.header').classList.add('sticky');

        if (e.direction == 1) {
            document.querySelector('.header').classList.add('hide')
        }

        if (e.direction == -1) {
            document.querySelector('.header').classList.remove('hide')
        }

    } else {
        document.querySelector('.header').classList.remove('sticky')
    }

});

function simulateClick(elem) {
    // Create our event (with options)
    var evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
    });
    // If cancelled, don't dispatch our event
    var canceled = !elem.dispatchEvent(evt);
};


window.addEventListener('resize', () => {





})

function isWpLoggedIn() {
    return !!document.getElementById('wpadminbar') || document.body.classList.contains('logged-in');
}

const loggedIn = isWpLoggedIn();


barba.init({
    prevent: ({ el, href, event }) => {
        if (loggedIn) return true; // Barba NON interviene → navigazione classica
        // comportamento normale per i non loggati (come avevi già):
        const inWpTopBar = el && (el.closest('#wpadminbar, #wp-toolbar') || el.matches('.ab-item'));
        const isWpAdmin = href && (href.includes('/wp-admin/') || href.includes('customize.php'));
        const specialClick = event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.which === 2);
        const newTabOrDownload = el && (el.target === '_blank' || el.hasAttribute('download'));
        return inWpTopBar || isWpAdmin || specialClick || newTabOrDownload;
    },

    transitions: [
        //TransitionTypo,
        TransitionDefault,
        //TransitionProduct
    ],
    views: [
        ViewHome,
        ViewTypo,
        ViewProduct,
        ViewAbout,
        ViewCases,
        ViewPage
    ]
});

barba.hooks.after(() => {
    initDownloadArea();
});

initDownloadArea();
initPromoBox();


document.addEventListener('DOMContentLoaded', () => {

    console.log('main js caricato');

    let $header = document.querySelector('.header');

    gsap.to('body', {
        duration: 1.5,
        opacity: 1,
        delay: 1,
    });




    let $menuToggle = document.querySelector('.header__mt');

    var tlMenu = gsap.timeline({
        paused: true
    });


    tlMenu.to('.site-menu', {
        x: 0,
        xPercent: 0,
        duration: .5
    });

    $menuToggle.addEventListener('click', () => {

        if ($menuToggle.classList.contains('opened')) {

            $menuToggle.classList.remove('opened');
            $header.classList.remove('sm-open');
            tlMenu.reverse()

            lenis.start()


        } else {
            $menuToggle.classList.add('opened')
            $header.classList.add('sm-open');
            tlMenu.play()
            lenis.stop()

            console.log(lenis)
            console.log('stop')
        }


    });


    const menu = document.querySelector('.site-menu__main');
    const links = menu.querySelectorAll('a');
    const imgs = document.querySelectorAll('.site-menu__image img');

    let current = null; // elemento img attualmente visibile

    imgs.forEach(img => gsap.set(img, { opacity: 0 }));
    const baseImg = document.querySelector('.site-menu__image img.is-base'); // aggiungi classe alla base
    if (baseImg) {
        gsap.set(baseImg, { opacity: 1 });
        current = baseImg;
    }

    document.querySelectorAll('.site-menu__secondary li a').forEach(el => {
        el.addEventListener('click', () => {

            $menuToggle.classList.remove('opened');
            $header.classList.remove('sm-open');
            tlMenu.reverse()

            lenis.start()

        });

    })

    document.querySelectorAll('.site-menu__tertiary li a').forEach(el => {
        el.addEventListener('click', () => {

            $menuToggle.classList.remove('opened');
            $header.classList.remove('sm-open');
            tlMenu.reverse()

            lenis.start()

        });

    })



    links.forEach(link => {


        link.addEventListener('click', () => {

            $menuToggle.classList.remove('opened');
            $header.classList.remove('sm-open');
            tlMenu.reverse()

            lenis.start()

        });



        link.addEventListener('mouseenter', () => {
            const sel = link.dataset.image; // es. "#img-two"
            const target = document.querySelector(sel);
            if (!target || target === current) return;

            // ferma subito tutto ciò che sta animando le immagini
            gsap.killTweensOf(imgs);

            // spegni tutte e accendi solo la target
            gsap.to(imgs, {
                opacity: 0,
                duration: 0.75,
                overwrite: 'auto'
            });
            gsap.to(target, {
                opacity: 1,
                duration: 0.75,
                overwrite: 'auto',
                onComplete: () => (current = target)
            });
        });
    });


    menu.addEventListener('mouseleave', () => {
        if (!baseImg || current === baseImg) return;
        gsap.killTweensOf(imgs);
        gsap.to(imgs, { opacity: 0, duration: 0.75, overwrite: 'auto' });
        gsap.to(baseImg, { opacity: 1, duration: 0.75, overwrite: 'auto', onComplete: () => (current = baseImg) });
    });



    let $menu_items = document.querySelectorAll('.site-menu__secondary li a');
    let menuAnimation = false;

    $menu_items.forEach(el => {

        el.addEventListener('mouseenter', () => {


            if (el.classList.contains('has-sub')) {

                let t = '#' + el.dataset.sub;

                if (!menuAnimation) {
                    menuAnimation = true;
                    gsap.to(t, {
                        opacity: 1,
                        onStart: () => {
                            gsap.set(t, {
                                display: 'block'
                            })
                        },
                        onComplete: () => {
                            menuAnimation = false
                        }
                    })

                }




            } else {


                if (!menuAnimation) {
                    menuAnimation = true;
                    gsap.to('.site-menu__tertiary', {
                        opacity: 0,
                        onComplete: () => {
                            gsap.set('.site-menu__tertiary', {
                                display: 'none'
                            })
                            menuAnimation = false;
                        }
                    })
                }




            }




        })





    })

})
